const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

class SupportCaseService {
  static async getCases(token) {
    const response = await fetch(`${API_BASE_URL}/support-cases`, {
      headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
    const result = await response.json();
    if (!result.success) throw new Error(result.message || 'Error al cargar solicitudes');
    return result;
  }

  static async getCase(id, token) {
    const response = await fetch(`${API_BASE_URL}/support-cases/${id}`, {
      headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
    const result = await response.json();
    if (!result.success) throw new Error(result.message || 'Error al cargar la solicitud');
    return result;
  }

  static async createCase({ title, description }, token) {
    const response = await fetch(`${API_BASE_URL}/support-cases`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ title, description })
    });
    const result = await response.json();
    if (!result.success) throw new Error(result.message || 'Error al crear la solicitud');
    return result;
  }

  static async addComment(id, body, token) {
    const response = await fetch(`${API_BASE_URL}/support-cases/${id}/comments`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ body })
    });
    const result = await response.json();
    if (!result.success) throw new Error(result.message || 'Error al enviar el comentario');
    return result;
  }
}

export default SupportCaseService;
